import { Reducer, AnyAction } from 'redux';
import { withSavedReportsReducer } from 'app/area/shared/saved-reports/reducers';
import {
  ACTION,
  RequestSavedReports, ReceiveSavedReports, FailSavedReports,
  RequestSaveSavedReports, ReceiveSaveSavedReports, FailSaveSavedReports,
  ClearSavedReports
} from './action-types';
import { DashboardComponentSavedReports } from './constants';
import { DashboardSavedReportsState } from './types-store';

export const INITIAL_STATE: DashboardSavedReportsState = {
  savedReports: undefined,
  originalSavedReports: undefined,
  description: undefined,
  typeId: undefined,
  fetching: false,
  saving: false,
  displayDisabled: false,
  currentSavedReportId: undefined,
  currentSavedReport: undefined,
  currentSavedReportOnlyIdMode: false,
  currentValidation: undefined,
  fetchingCurrentEvaluation: false,
  fetchingAddSavedReports: false,
  savedReportsValidation: {}
};

const reducers: { [indexer: string]: Reducer<DashboardSavedReportsState> } = {

  [ACTION.REQUEST_SAVED_REPORTS]: (state: DashboardSavedReportsState,
    action: RequestSavedReports): DashboardSavedReportsState => {

    return {
      ...state,
      savedReports: undefined,
      originalSavedReports: undefined,
      description: undefined,
      typeId: action.dashboardTypeId,
      fetching: true,
      saving: false,
      currentSavedReport: undefined,
      savedReportsValidation: {}
    };
  },

  [ACTION.RECEIVE_SAVED_REPORTS]: (state: DashboardSavedReportsState,
    action: ReceiveSavedReports): DashboardSavedReportsState => {

    return state.typeId === action.dashboardTypeId
      ? {
        ...state,
        savedReports: action.savedReports,
        originalSavedReports: action.savedReports,
        description: action.description,
        fetching: false
      }
      : state;
  },

  [ACTION.FAIL_SAVED_REPORTS]: (state: DashboardSavedReportsState,
    action: FailSavedReports): DashboardSavedReportsState => {

    return state.typeId === action.dashboardTypeId
      ? {
        ...state,
        fetching: false
      }
      : state;
  },

  [ACTION.REQUEST_SAVE_SAVED_REPORTS]: (state: DashboardSavedReportsState,
    action: RequestSaveSavedReports): DashboardSavedReportsState => {

    return {
      ...state,
      typeId: action.dashboardTypeId,
      saving: true
    };
  },

  [ACTION.RECEIVE_SAVE_SAVED_REPORTS]: (state: DashboardSavedReportsState,
    action: ReceiveSaveSavedReports): DashboardSavedReportsState => {

    return state.typeId === action.dashboardTypeId
      ? {
        ...state,
        originalSavedReports: state.savedReports,
        saving: false
      }
      : state;
  },

  [ACTION.FAIL_SAVE_SAVED_REPORTS]: (state: DashboardSavedReportsState,
    action: FailSaveSavedReports): DashboardSavedReportsState => {

    return state.typeId === action.dashboardTypeId
      ? {
        ...state,
        saving: false
      }
      : state;
  },

  [ACTION.CLEAR_SAVED_REPORTS]: (state: DashboardSavedReportsState,
    action: ClearSavedReports): DashboardSavedReportsState => {

    return {
      ...state,
      ...INITIAL_STATE
    };
  }
};

const pureReducer: Reducer<DashboardSavedReportsState> = (
  state: DashboardSavedReportsState = INITIAL_STATE, action: AnyAction) => {
  const r = reducers[action.type];
  return (r && r(state, action)) || state;
};

export const reducer = withSavedReportsReducer(DashboardComponentSavedReports, pureReducer);
